export const PP_ACTION_TYPES = {
    FETCH_PRODUCT_PLATFORMS_START: 'bu/FETCH_PRODUCT_PLATFORMS_START',
    FETCH_PRODUCT_PLATFORMS_SUCCESS: 'bu/FETCH_PRODUCT_PLATFORMS_SUCCESS',
    FETCH_PRODUCT_PLATFORMS_FAILED: 'bu/FETCH_PRODUCT_PLATFORMS_FAILED',
};